export default {
  default: [
    {
      path: "spaarder/:funderId/account/aanmaken",
      name: "funderAccount.create",
      component: () => import("./views/AccountFormView.vue"),
    },
    {
      path: "spaarder/:funderId/bedrijfs-account/aanmaken",
      name: "funderBusinessAccount.create",
      component: () => import("./views/AccountFormView.vue"),
    },
    {
      path: "spaarder/:funderId/account/:id/wijzigen",
      name: "funderAccount.edit",
      component: () => import("./views/AccountFormView.vue"),
    },
    {
      path: "spaarder/:funderId/bedrijfs-account/:id/wijzigen",
      name: "funderBusinessAccount.edit",
      component: () => import("./views/AccountFormView.vue"),
    },
  ],
};
